module.exports = __webpack_public_path__ + "img/heyworld.e887fabe.png";